// extracted by mini-css-extract-plugin
export default {"textarea":"styles_textarea__jjc9h","over":"styles_over__RVyXL","counter":"styles_counter__isY1q","counterOver":"styles_counterOver__uDc1e"};